import { render } from "./RatioContainer.vue?vue&type=template&id=884c2278&scoped=true"
import script from "./RatioContainer.vue?vue&type=script&lang=js"
export * from "./RatioContainer.vue?vue&type=script&lang=js"

import "./RatioContainer.vue?vue&type=style&index=0&id=884c2278&lang=scss&scoped=true"
import "./RatioContainer.vue?vue&type=style&index=1&id=884c2278&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-884c2278"]])

export default __exports__